import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from 'react-router-dom'
import C18Input00 from './C18Input00'
import C18InputError00 from './C18InputError00'
import C18Button00 from './C18Button00'
import C18Anchor00 from './C18Anchor00'
import history from "../../history"
import { wsTrans, saveTokens } from '../utils/utils'
import { cl, globs, constant, getTZName } from '../../components/utils/utils';
import PhoneInput from './PhoneInput';

class C18Register00 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "",
      companyNameError: "",
      name: "",
      nameError: "",
      email1: "",
      email1Error: "",
      email2: "",
      email2Error: "",
      password1: "",
      password1Visible: false,
      password1Error: "",
      password2: "",
      password2Visible: false,
      password2Type: "",
      password2Error: "",
      eulaChecked: false,
      eulaError: "",
      mfaEnabled: false,// C20C22-4541 MFA: email sign in code at login
      noteInfo: { enableSMS: false },
      smsError: "",
      navClass: " ",
      recaptchaResponse: null,
      // mobilePhone: "",
      mobilePhoneError: "",
      country: '',
      // countryCode: "",
      // fullNumber:"",
      // countryIso: '',
      selectedPlan: '',
      planConfigs: null,
    }
    this.alerts = [
      "Just fill in the fields, and press Register!",//0
      "Company Name Cannot Be Blank",//1
      "Company Name is In Use ",//2
      "Your Name Cannot Be Blank",//3
      "Email Cannot Be Blank",//4
      "Email is In Use ",//5
      "Please Enter a Valid Email",//6
      "Emails Don't Match ",//7
      "Password Cannot Be Blank",//8
      "Password is Too Short",//9
      "Passwords Don't Match",//10
      "What a Super-Duper Password!",//11
      "Checking . . .",//12
      "Password is Too Common ",//13
      "Please accept the EULA terms",//14
      "Just Press Register!",//15
      "Mobile Phone cannot be blank",//16
      "Enter a valid phone number",//17
      "Phone number must be between 10 and 15 digits", //18

    ];
    if (props.mode == "activate") this.activateUser(props.token);
  }

  componentDidMount() {
    this.loadPlanConfigs()
  }

  loadPlanConfigs = async () => {
    // cl("HydroR Trial fetching public planConfigs for signup form")
    try {
      let res = await wsTrans("usa", {
        cmd: "cRest", uri: "/o/users/register", method: "planConfigs", body: {}
      })
      if (res.result === "ok" && res.data) {
        let codes = Object.keys(res.data)
        // cl("HydroR Trial planConfigs loaded, plans:", codes)
        this.setState({
          planConfigs: res.data,
          selectedPlan: codes.length > 0 ? codes[0] : '',
        })
      }
    } catch (e) { cl("HydroR Trial error loading planConfigs", e) }
  }

  mySetState = (vals) => {
    var state = {}
    Object.assign(state, this.state, vals)
    this.validate(state)
    this.setState(vals)
  }

  onChange = (type, vals) => {
    //     cl([type,vals])
    switch (type) {
      case "input":
        this.mySetState(vals)
        //         this.validate()
        break
      case "visibility":
        let type = (vals.id == "if-password1") ? "password1Visible" : "password2Visible"
        let upd = { [type]: !this.state[type] }
        cl(upd)
        this.setState(upd)
        break
      case "check":
        this.mySetState(vals)
        break
      default:
        break
    }
  }

  onReCaptcha = (e) => {
    //     cl(e)
    this.setState({ recaptchaResponse: e });
  }

  emailsDiffer = () => {
    return !((this.state.email1 === "") || (this.state.email2 === "") || (this.state.email1 === this.state.email2));
  }

  emailsEmpty = () => {
    return (this.state.email1 === "");
  }

  setAlert = (n) => {
    let state = this.state
    var companyNameError, nameError, email1Error, email2Error, password1Error, password2Error, cellPhoneError, eulaError
    switch (n) {
      case 1:
      case 2:
        companyNameError = this.alerts[n]
        break
      case 3:
        nameError = this.alerts[n]
        break
      case 4:
      case 5:
      case 6:
        email1Error = this.alerts[n]
        break
      case 7:
        email2Error = this.alerts[n]
        break
      case 8:
      case 9:
      case 13:
        password1Error = this.alerts[n]
        break
      case 10:
      case 11:
        password2Error = this.alerts[n]
        break
      case 14:
        eulaError = this.alerts[n]
        break;
      case 16:
      case 17:
      case 18:
        cellPhoneError = this.alerts[n];
        break;
    }
    //     cl("alert: " + n);
    this.setState({
      companyNameError: companyNameError,
      nameError: nameError,
      email1Error: email1Error,
      email2Error: email2Error,
      password1Error: password1Error,
      password2Error: password2Error,
      eulaError: eulaError,
      cellPhoneError: cellPhoneError,
      alertId: n
    });
  }

  validEmail = (email) => {
    let atPos = email.indexOf("@");
    let perPos = email.lastIndexOf(".");
    return ((atPos > 0) && (perPos > atPos));
  }

  validate = (state) => {
    /*
    alert lines:
    That Company Name is Already in Use
    Please Fill in Your Name
    Please fill in the Email Fields
    Email Fields don't Match
    That Email is Already in Use
    Please Fill in the Password Fields
    Password Fields don't Match
    That Password is Commonly Used
    What a Super Duper Password!
    */
    //     let msg = "Please fill in the emails";
    //     cl("validate");
    //     cl(state.companyName)
    if (state.companyName === "") return this.setAlert(1);
    //     if(!state.uc) return this.setAlert(2)
    if (state.name === "") return this.setAlert(3);
    if (state.email1 + state.email2 === "") return this.setAlert(4);
    if (!this.validEmail(state.email1)) return this.setAlert(6);

    if (state.email1 !== state.email2) return this.setAlert(7);
    if (state.password1 + state.password2 === "") return this.setAlert(8);
    if (state.password1.length < 6) return this.setAlert(9);
    if (state.password1 !== state.password2) return this.setAlert(10);
    if (!state.eulaChecked) return this.setAlert(14)
    if (state.cellPhone === "") return this.setAlert(16);
    // const phone = state.cellPhone.trim();
    // const usPhoneRegex = /^\+[0-9]{12}$/;
    // if (!usPhoneRegex.test(phone)) return this.setAlert(17);

    //      if(this.emailsDiffer()) this.setState({alertMessage: "The emails are different"});
    //      if (this.state.companyName + this.state.name + this.state.email1 + this.state.email2 + this.state.password1 + this.state.password2 === "") return this.setAlert(0);
    this.checkFields(state)
    //     if(state.password1==="password") return this.setAlert(11);
    return this.setAlert(12);

  }

  checkFields = async (state) => {
    this.timeoutIF = null;
    //     cl("checking");
    let res = await wsTrans("usa", {
      cmd: "cRest", uri: "/o/users/unique", method: "retrieve",
      body: { companyName: state.companyName, email: state.email1, password: state.password1 }
    })
    //     cl(res)
    //     cl(res.uc)
    //     cl("check")
    if (!res.uc && (this.state.alertId > 2)) return this.setAlert(2);// company name used
    //     cl("check")
    if (!res.ue && (this.state.alertId > 5)) return this.setAlert(5);// email used
    //     cl("check")
    if (!res.up && (this.state.alertId > 11)) return this.setAlert(13);// password fails
    //     cl("check")
    if (this.state.alertId === 12) this.setAlert(15);
  }

  activateUser = async (token) => {
    //  cl(this.props)
    let r = await wsTrans("usa", {
      cmd: "cRest", uri: "/o/users/activate", method: "retrieve",
      body: { token: token }
    })
    //  cl(r)
    // redirect to 
    if (r.result == "notFound") {
      history.push('/usa/c18/login')
    } else {
      saveTokens(r.data.accessToken, r.data.refreshToken, r.session);// should set logged in true
      history.push('/usa/c18/admin/userProfile');
    }
  }

  postRegister = (token) => {
    globs.npi = { name: this.state.name, email: this.state.email1, token: token };
    history.push('/usa/c18/postRegister');
  }

  butClick = async (e) => {
    // cl('this.props', this.props)
    // cl('THIS.STATE', this.state)
    const { countryCode, countryIso, fullNumber } = this.state;
    let da = new Date()
    da.setMonth(0)// to standard time for this year
    let tzo = da.getTimezoneOffset()
    let tz = getTZName(tzo)
    //     cl(tzo)
    //     cl(tz)
    //     return

    // cl("HydroR Trial registering user with selectedPlan:", this.state.selectedPlan)
    let res = await wsTrans("usa", {
      cmd: "cRest", uri: "/o/users/register", method: "create",
      body: {
        companyName: this.state.companyName,
        name: this.state.name,
        email: this.state.email1,
        password: this.state.password1,
        mobilePhone: fullNumber,
        countryCode,
        countryIso,
        noteInfo: {
        enableSMS: this.state.noteInfo.enableSMS
        },
        recaptchaResponse: this.state.recaptchaResponse,
        developer: (this.props.mode == "devRegister"),
        timezone: tz,
        selectedPlan: this.state.selectedPlan,
        mfaEnabled: !!this.state.mfaEnabled,// C20C22-4541 MFA
      }
    })   
    // cl("HydroR Trial register response:", res.result)
    if (res.result === "ok") { this.postRegister(res.data.token) } else {
      //       cl(res)
      this.setState({ password2Error: "reCaptcha Error" })
    }
  }

  //   showInputErrorField=(parms)=>{
  //     let messageClass={
  //       error:"input-error-message",
  //     }[parms.messageType]
  //     let divClass=`text-input-wrapper${(parms.message)?" input-error":""}`
  //     if(parms.type=="password"){
  //       let type=(parms.visible)?"text":"password"
  //       
  //       return(
  //         <div className={divClass}>
  //           <label htmlFor={parms.id}>{parms.title}</label>
  //           <div id="password-container">
  //             <C18Input00 id={parms.id} type={type} required={parms.required}
  //               value={parms.value}
  //               onChange={e=>this.onChange("input", {[parms.valueId]: e.currentTarget.value})}
  //             />
  //             <C18Button00 id="visible-button" type="button" aria-label="toggle password visibility">
  //               <span className="material-icons"
  //                 onClick={e=>parms.onChange("visibility", {id: parms.id})}
  //               >
  //                 {(parms.visible)?"visibility_off":"visibility"}
  //                 </span>
  //             </C18Button00>
  //             <div className={messageClass}>{parms.message}</div>
  //           </div>
  //         </div>
  //       )
  //     }else{
  //       return(
  //         <div className={divClass}>
  //           <label htmlFor={parms.id}>{parms.title}</label>
  //           <C18Input00 id={parms.id} type={parms.type} required={parms.required}
  //             value={parms.value}
  //             onChange={e=>this.onChange("input", {[parms.valueId]: e.currentTarget.value})}
  //           />
  //           <div className={messageClass}>{parms.message}</div>
  //         </div>
  //       )
  //     }
  //   }

  showEulaLink = () => {
    // <Link to={"/eula/eula.html"}>End User License Agreement</Link>    
    return (
      <a target="_blank" href={"/eula/eula.html"}>End User License Agreement</a>
    )
  }
  showPrivacyPolicyLink = () => {
    // <Link to={"/eula/eula.html"}>End User License Agreement</Link>    
    return (
      <a target="_blank" href={"/eula/privacy-policy.html"}>Privacy Policy</a>
    )
  }

  isOtto = () => {
    return this.state.companyName == "Automated Testing"
  }

  render() {
    //               <div>{this.alerts[this.state.alertId]}</div>
    //     cl(this.state.alertId)
    let st = this.state
    //     cl(st)
    let al = this.state.alertId
    let okRegister = ((al == 11) || (al == 15)) && (this.state.recaptchaResponse || (this.isOtto()))
    return (
      <div>
        <div className="login-register-new">

          <div className="login-left register">
          </div>

          <div id="/register" className="login-right">

            <header>
              <div className="floatleft">
                <a href="https://link4controls.com/" className="main-logo"><img src="/img/link4_logo_blue_trans.png" alt="Link4 Controls logo" /></a>
              </div>
              <div className="floatright">
                Have an account? <C18Anchor00 id="back-to-login" to="/usa/c18/login">Log In</C18Anchor00>
              </div>
            </header>

            <form className="register">
              <h1>Welcome to Link4!</h1>

              <C18InputError00 parms={{
                type: 'text',
                title: "Company Name",
                id: "if-companyName",
                required: true,
                value: this.state.companyName,
                valueId: "companyName",
                onChange: this.onChange,
                message: this.state.companyNameError,
                messageType: "error"
              }} />
              <C18InputError00 parms={{
                type: 'text',
                title: "Your Name",
                id: "if-name",
                required: true,
                value: this.state.name,
                valueId: "name",
                onChange: this.onChange,
                message: this.state.nameError,
                messageType: "error"
              }} />
              {/* C20C22-4541 MFA: shown near the top so users notice the new option. Optional, not needed to register */}
              {/* checkbox-field: same iOS rescue rule as other checkboxes (common.scss), flexShrink 0 so it never gets squeezed */}
              <div className="checkbox-field" style={{ clear: "both", display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
                margin: "0 0 1em", background: "#e8f1fb", border: "1px solid #b9d3f0", borderRadius: 6,
                color: "#1a4f8b", fontSize: 14, fontWeight: 500 }}>
                <C18Input00 id="mfa-box" type="checkbox"
                  style={{ margin: 0, flexShrink: 0 }}
                  checked={this.state.mfaEnabled}
                  onChange={e => this.setState({ mfaEnabled: e.currentTarget.checked })}
                />
                <div>
                  <label htmlFor="mfa-box" style={{ margin: 0 }}>Enable email verification code on sign-in (MFA)</label>
                  <div style={{ fontSize: 12, fontWeight: 400, color: "#555" }}>Optional. You can turn it on later in User Profile.</div>
                </div>
              </div>
              <C18InputError00 parms={{
                type: 'email',
                title: "Your Email",
                id: "if-email1",
                required: true,
                value: this.state.email1,
                valueId: "email1",
                onChange: this.onChange,
                message: this.state.email1Error,
                messageType: "error"
              }} />
              <C18InputError00 parms={{
                type: 'email',
                title: "Confirm Email",
                id: "if-email2",
                required: true,
                value: this.state.email2,
                valueId: "email2",
                onChange: this.onChange,
                message: this.state.email2Error,
                messageType: "error"
              }} />


              <C18InputError00 parms={{
                type: 'password',
                visible: this.state.password1Visible,
                title: "Your Password",
                id: "if-password1",
                required: true,
                value: this.state.password1,
                valueId: "password1",
                onChange: this.onChange,
                message: this.state.password1Error,
                messageType: "error"
              }} />
              <C18InputError00 parms={{
                type: 'password',
                visible: this.state.password2Visible,
                title: "Confirm Password",
                id: "if-password2",
                required: true,
                value: this.state.password2,
                valueId: "password2",
                onChange: this.onChange,
                message: this.state.password2Error,
                messageType: "error"
              }} />
              {/* <C18InputError00 parms={{
                type: 'text',
                title: "Mobile Phone",
                id: "if-cellPhone",
                required: false,
                value: this.state.cellPhone,
                valueId: "cellPhone",
                onChange: this.onChange,
                message: this.state.cellPhoneError,
                messageType: "error",
                placeholder: "+1XXXXXXXXXX"
              }} /> */}
                <label
                  htmlFor="mobilePhone"
                  style={{
                  display: "block",
                  fontWeight: 600,
                  marginBottom: 8,
                  color: "#6E6B7B",
                 }}
                >
                Mobile Phone Number for SMS
               </label>
              <PhoneInput
                country={this.state.country}
                title={"Mobile Phone"}
                countryCode={this.state.countryCode}
                mobilePhone={this.state.mobilePhone}
                selectedCountry={this.state.country?.toLowerCase() || "us"}
                // clearMobileError={() => this.setState({ showMobileError: false, mobileErrorMsg: "" })}
                onChange={({ fullNumber, countryCode, mobilePhone, countryIso }) =>
                  this.setState({ countryCode, mobilePhone, fullNumber, countryIso })
                }
              />

              {this.state.planConfigs && Object.keys(this.state.planConfigs).length > 1 &&
                <div className="text-input-wrapper" style={{ marginBottom: 16 }}>
                  <label htmlFor="if-selectedPlan" style={{
                    display: "block", fontWeight: 600, marginBottom: 8, color: "#6E6B7B",
                  }}>Subscription Plan</label>
                  <select id="if-selectedPlan"
                    value={this.state.selectedPlan}
                    onChange={e => this.setState({ selectedPlan: e.target.value })}
                    style={{
                      width: "100%", padding: "10px 12px", borderRadius: 5,
                      border: "1px solid #D8D6DE", fontSize: 14, color: "#6E6B7B",
                      backgroundColor: "#fff",
                    }}
                  >
                    {Object.entries(this.state.planConfigs).map(([code, cfg]) =>
                      <option key={code} value={code}>{cfg.label}</option>
                    )}
                  </select>
                </div>
              }

              <div className="remember-container">
                <div id="remember-me-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "5px",
                    // gap: "8px",
                    // flexWrap: "wrap",
                  }} >
                  <C18Input00 id="sms-box" type="checkbox"
                    // style={{ padding: "10.5px 12px" }}
                    checked={this.state.noteInfo.enableSMS}
                    onChange={(e) => this.setState({
                    noteInfo: { ...this.state.noteInfo , enableSMS: e.currentTarget.checked}})}
                  /><label htmlFor="sms-box">I consent to receive SMS alerts about alarms from Link4 Controls. {this.showPrivacyPolicyLink()}</label>
                </div>
                <div id="remember-me-container">
                  <C18Input00 id="eula-box" type="checkbox"
                    style={{ padding: "10.5px 12px" }}
                    checked={this.state.eulaChecked}
                    onChange={e => this.onChange("check", { eulaChecked: e.currentTarget.checked })}
                  /><label htmlFor="eula-box">I accept the {this.showEulaLink()}</label>
                </div>
                <div className="text-input-wrapper input-error">
                  <div className="input-error-message"
                    style={{ marginTop: 12 }}>{this.state.eulaError}</div>
                </div>
              </div>

              {!this.isOtto() &&
                <div className="recaptcha-wrapper">
                  <div className="recaptcha-container">
                    <ReCAPTCHA
                      sitekey="6LergcwZAAAAAEZu1hJC5b7s8ar2JSHvgyfgbYpx"
                      onChange={this.onReCaptcha}
                    />
                  </div>
                </div>
              }

              <div className="button-container">
                <C18Button00 className="filled" disabled={!okRegister}
                  tabIndex="0" type="button" id="register-button" onClick={this.butClick}>Register
                </C18Button00>
              </div>





            </form>

            <div id="footer" className="register">
              <p>Cloud-Based Environmental Controls</p>
              <p>Copyright &copy;2021 Link4 Corporation. All Rights Reserved.</p>
            </div>

          </div>

        </div>
      </div>
    )
  }
}

export default C18Register00;
